import { useState } from "react"
import { useApi } from "./useApi"
import { useLoader } from "../context/loaders/useLoader"
import { useToast } from "../context/toasts/useToast"
import { LoginHistoryEntry, ChangePasswordData } from "../types"

export function useProfile() {
  const [loginHistory, setLoginHistory] = useState<LoginHistoryEntry[]>([])
  const [error, setError] = useState<string | null>(null)

  const { changePassword: changePasswordApi, getLoginHistory: getLoginHistoryApi } = useApi()
  const { withLoader } = useLoader()
  const { addNotification } = useToast()

  const fetchLoginHistory = async () => {
    try {
      setError(null)
      const data = await withLoader(
        () => getLoginHistoryApi(20),
        "Loading login history..."
      )
      if (data) {
        setLoginHistory(data)
      }
      return data
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : "Failed to load login history"
      setError(errorMessage)
      addNotification({
        type: "error",
        title: "Error",
        message: errorMessage,
        duration: 5000,
      })
      return []
    }
  }

  const handleChangePassword = async (data: ChangePasswordData) => {
    try {
      setError(null)
      await withLoader(
        () => changePasswordApi(data),
        "Changing password..."
      )
      addNotification({
        type: "success",
        title: "Password Changed",
        message: "Your password has been updated successfully.",
        duration: 3000,
      })
      return true
    } catch (err: unknown) {
      const axiosError = err as { response?: { data?: { error?: string } }; message?: string }
      const errorMessage =
        axiosError.response?.data?.error || axiosError.message || "Failed to change password"
      setError(errorMessage)
      addNotification({
        type: "error",
        title: "Error",
        message: errorMessage,
        duration: 5000,
      })
      return false
    }
  }

  return {
    loginHistory,
    error,
    fetchLoginHistory,
    changePassword: handleChangePassword,
  }
}